export enum WinningModalStep {
  FORM = 'form',
  REVIEW = 'review',
  SAVED = 'saved',
}